import React from 'react'

import { SxProps } from '@mui/material'

import Icon from 'components_new/atoms/Icon'

import GroupAvatar from 'components_new/molecules/GroupAvatar'
import SectionHeader from 'components_new/molecules/SectionHeader'

import { useGroup } from 'redux/hooks/Groups'
import { useParams } from 'utils/hooks'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

import Loading from './loading'

interface GroupHeaderProps {
  sx?: SxProps
}

const GroupHeader = (props: GroupHeaderProps) => {
  const { sx } = props

  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  const group = useGroup(id)
  const { loading: accountLoading } = useAccountSettings()

  if (!group || accountLoading) {
    return <Loading />
  }

  const membersString = t(
    'global',
    group.active_members.length === 1 ? 'member' : 'members',
    true
  )

  const dashboardsString = t(
    'global',
    group.dashboards.length === 1 ? 'dashboard' : 'dashboards',
    true
  )

  return (
    <SectionHeader
      body={
        <>
          {group.active_members.length} {membersString} •{' '}
          {group.dashboards.length} {dashboardsString}
        </>
      }
      icon={
        <GroupAvatar
          color={group.profile_color}
          size="large"
          title={group.name}
        />
      }
      size="large"
      sx={sx}
      title={group.name}
      titleAdornment={group.is_private ? <Icon name="Private" /> : undefined}
    />
  )
}

export default GroupHeader
